import { styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';
import { EnhancedGradientCardBgColor } from '../../../config';

export const EnhancedCardContainer = styled(SRoundedContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  width: '100%',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  background: EnhancedGradientCardBgColor,
  height: '100%',
  minHeight: '187px'
}));
